import axios from "axios";
import Cookies from "js-cookie";
import jwtParse from "./helper/jwtParse";

export const authApi = axios.create({
  baseURL: process.env.REACT_APP_AUTHAPI_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

export const getAuthToken = async () => {
  const token = Cookies.get("authToken");
  if (!token) return null;
  const { exp } = jwtParse(token);
  if (!exp || exp < Date.now() / 1000) {
    const response = await getTokenRefresh();
    if (!response || response.status !== "200") return null;
    Cookies.set("authToken", response.response.token);
    Cookies.set("refreshToken", response.response.refreshToken);
    return response.response.token;
  }
  return token;
};

export const getAccessToken = async (username, password, options = {}) => {
  const requestBody = {
    playerId: options.playerId || "",
    userName: username,
    password,
    isSocialLogin: options.isSocialLogin || false,
    isFacebook: false,
    isGoogle: options.isGoogle || false,
    isAppleLogin: options.isAppleLogin || false,
    isFacialLoginAllowed: false,
    socialToken: options.socialToken || null,
    stoken: options.socialToken || null, 
  };
  const { data } = await authApi.post("api/v4/token/access-token", requestBody);
  return data;
};

export const getTokenRefresh = async () => {
  const token = Cookies.get("authToken");
  const refreshToken = Cookies.get("refreshToken");
  if (!token || !refreshToken) {
    throw new Error("Error accessing cookies");
  }
  const requestBody = { token, refreshToken };
  const { data } = await authApi.post("api/v1/token/refresh", requestBody);
  return data;
};


export const signupGamer = async (signupData) => {
  const requestBody = {
    userId: 0, 
    userName: signupData.username,
    firstName: signupData.firstName || "",
    lastName: signupData.lastName || "",
    email: signupData.email,
    password: signupData.password,
    phoneNumber: signupData.phoneNumber || null, 
    dateOfBirth: signupData.dateOfBirth,
    gender: signupData.gender,
    isSocialLogin: signupData.isSocialLogin || false,
    isGoogle: signupData.isGoogle || false,
    isAppleLogin: signupData.isAppleLogin || false,
    isFacebook: false,
    isFacialLoginAllowed: false,
    latitude: signupData.latitude || 0,
    longitude: signupData.longitude || 0,
    countryCodeName: signupData.countryCodeName || "US",
    token: signupData.token || null,
    playerId: signupData.playerId || "",
  };

  const { data } = await authApi.post("api/v2/account/user-signup", requestBody);
  return data;
};

export const socialSignupGamer = async (signupData) => {
  const requestBody = {
    userId: 0,
    userName: signupData.username,
    firstName: signupData.firstName || "",
    lastName: signupData.lastName || "",
    email: signupData.email,
    password: signupData.password, 
    phoneNumber: signupData.phoneNumber || null,
    dateOfBirth: signupData.dateOfBirth || null, 
    gender: signupData.gender || "male",
    isSocialLogin: true,
    isGoogle: signupData.isGoogle || false,
    isAppleLogin: signupData.isAppleLogin || false,
    isFacebook: false,
    isFacialLoginAllowed: false,
    latitude: signupData.latitude || 0,
    longitude: signupData.longitude || 0,
    countryCodeName: signupData.countryCodeName || "US",
    token: signupData.token, 
    playerId: signupData.playerId || "",
  };

  const { data } = await authApi.post("api/v2/account/user-signup", requestBody);
  return data;
};

export const sendSignupVerificationCode = async (username, token) => {
  const encodedUsername = encodeURIComponent(username);
  const queryParams = `username=${encodedUsername}&IsSms=false&IsEmail=true&IsAppleLogin=false&Token=${token}&accountType=gamer`;
  const { data } = await authApi.get(`/api/v1/account/send-accesscode-for-signup?${queryParams}`);
  return data;
};


export const verifySignupCode = async (username, code, token) => {
  const encodedUsername = encodeURIComponent(username);
  const queryParams = `username=${encodedUsername}&accessCode=${code}&IsAppleLogin=false&Token=${token}&accountType=gamer`;
  const { data } = await authApi.get(`/api/v1/account/validate-accesscode-for-signup?${queryParams}`);
  return data;
};

export const getPrivacyPolicyOrTerms = async (title) => {
  const encodedTitle = encodeURIComponent(title);
  const { data } = await authApi.get(`api/v1/account/get-privacypolicy-termscondition?title=${encodedTitle}`);
  return data;
};

export const sendForgotPasswordCode = async (email, accountType = "gamer") => {
  const encodedEmail = encodeURIComponent(email);
  const queryParams = `details=${encodedEmail}&IsSms=false&IsEmail=true&accountType=${accountType}`;
  const { data } = await authApi.get(`api/v1/account/forgotpassword-send-accesscode?${queryParams}`);
  return data;
};


export const verifyForgotPasswordCode = async (email, code, accountType = "gamer") => {
  const encodedEmail = encodeURIComponent(email);
  const queryParams = `userName=${encodedEmail}&accessCode=${code}&accountType=${accountType}`;
  const { data } = await authApi.get(`api/v1/account/validate-accesscode?${queryParams}`);
  return data;
};

export const resetPassword = async (userId, newPassword) => {
  const requestBody = {
    userId,
    newPassword,
    confirmPassword: newPassword
  };
  const { data } = await authApi.post("api/v1/account/reset-password", requestBody);
  return data;
};